export const MEDIA_BREAKPOINTS = [1200, 1400];
export const FIXED_PARTICIPANTS_COUNT = [9, 16, 25];
